import PropTypes from 'prop-types'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

const GenericInputField = ({ hidden, error, caption, isEditable, value, onBlur, label, id, missing = false }) => {
  if (hidden) {
    return null
  }
  return (
    <SDFormControl plainLabel error={error} caption={caption}>
      <SDInput
        label={label}
        disabled={isEditable === false}
        id={id}
        onBlur={onBlur}
        currentValue={value}
        missing={missing}
        endEnhancer={<CopyEndEnhancer value={value} />}
      />
    </SDFormControl>
  )
}

GenericInputField.propTypes = {
  hidden: PropTypes.bool,
  error: PropTypes.string,
  caption: PropTypes.string,
  isEditable: PropTypes.bool,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
  missing: PropTypes.bool,
}

export default GenericInputField
